import { render, staticRenderFns } from "./DialogCreateRevenueCategories.vue?vue&type=template&id=31c5c709&scoped=true&"
import script from "./DialogCreateRevenueCategories.vue?vue&type=script&lang=js&"
export * from "./DialogCreateRevenueCategories.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateRevenueCategories.vue?vue&type=style&index=0&id=31c5c709&lang=scss&scoped=true&"
import style1 from "./DialogCreateRevenueCategories.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DialogCreateRevenueCategories.vue?vue&type=style&index=2&id=31c5c709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5c709",
  null
  
)

export default component.exports